import { ENV } from "../../../../utils/constants";

export const LIMIT_OPTIONS = [10, 20, 50];

export function getSummaryResponse(result) {
  return result?.summary || result?.response || result || {};
}

export function getExistencesResponse(result) {
  const response = result?.existences || result?.response || result || {};

  if (Array.isArray(response.docs)) {
    return response;
  }

  if (Array.isArray(response)) {
    return {
      docs: response,
      totalDocs: response.length,
      totalPages: 1,
      page: 1,
      limit: response.length,
    };
  }

  return {
    docs: [],
    totalDocs: 0,
    totalPages: 1,
    page: 1,
    limit: 10,
  };
}

export function getImageUrl(imagePath) {
  if (!imagePath) {
    return "";
  }

  const value = String(imagePath);

  if (
    value.startsWith("http://") ||
    value.startsWith("https://") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  return `${ENV.SERVER_HOST}/${value
    .replace(/\\/g, "/")
    .replace(/^\/+/, "")}`;
}

export function getProductImage(product) {
  const images = Array.isArray(product?.images) ? product.images : [];

  const coverImage =
    images.find((image) => image?.isCover) || images[0];

  return getImageUrl(coverImage?.path);
}

export function getAttributeName(attribute) {
  if (attribute?.schema && typeof attribute.schema === "object") {
    return attribute.schema.name || "";
  }

  return attribute?.name || "";
}

export function getAttributeValue(attribute) {
  if (
    attribute?.classification &&
    typeof attribute.classification === "object"
  ) {
    return (
      attribute.classification.name ||
      attribute.classification.value ||
      attribute.value ||
      ""
    );
  }

  return attribute?.label || attribute?.value || "";
}

export function getVariantLabel(variant) {
  const attributes = Array.isArray(variant?.attributes)
    ? variant.attributes
    : [];

  if (attributes.length === 0) {
    return "Variante única";
  }

  return attributes
    .map((attribute) => {
      const attributeName = getAttributeName(attribute);
      const attributeValue = getAttributeValue(attribute);

      if (attributeName && attributeValue) {
        return `${attributeName}: ${attributeValue}`;
      }

      return attributeValue || attributeName;
    })
    .filter(Boolean)
    .join(" · ");
}

export function getStockStatus(variant) {
  const stock = Number(variant?.stock) || 0;
  const lowStockAlert = Number(variant?.lowStockAlert) || 0;

  if (stock <= 0) {
    return {
      label: "Sin stock",
      status: "out",
    };
  }

  if (lowStockAlert > 0 && stock <= lowStockAlert) {
    return {
      label: "Bajo stock",
      status: "low",
    };
  }

  return {
    label: "Óptimo",
    status: "optimal",
  };
}

export function flattenExistences(products = []) {
  if (!Array.isArray(products)) {
    return [];
  }

  return products.flatMap((product) => {
    const variants = Array.isArray(product?.variants)
      ? product.variants
      : [];

    return variants.map((variant) => ({
      productId: product._id,
      productCode: product.id || "",
      productName: product.name || "",
      productImage: getProductImage(product),
      categoryName:
        typeof product.category === "object"
          ? product.category?.name || "Sin categoría"
          : "Sin categoría",
      variantId: variant._id,
      sku: variant.sku || "—",
      variantLabel: getVariantLabel(variant),
      stock: Number(variant.stock) || 0,
      availableStock: Math.max(Number(variant.stock) || 0, 0),
      lowStockAlert: Number(variant.lowStockAlert) || 0,
      enabled: variant.enabled !== false,
      stockStatus: getStockStatus(variant),
    }));
  });
}

export function formatNumber(value) {
  return (Number(value) || 0).toLocaleString("es-GT");
}

export function formatCurrency(value) {
  return `Q ${(Number(value) || 0).toLocaleString("es-GT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}